import CheckTreePicker from './CheckTreePicker';

// export types
export type { CheckTreePickerProps } from './CheckTreePicker';

// export components
export { CheckTreePicker };
export default CheckTreePicker;
